import Model, { attr, hasMany } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export type ReportTypes =
  | 'booking'
  | 'booking_legacy'
  | 'check_in'
  | 'check_out'
  | 'daily_occupancy';

export default class ReportModel extends Model {
  @attr('date') from!: Date;
  @attr('date') to!: Date;
  @attr('boolean') includeCancelled!: boolean;
  @attr('array') types!: ReportTypes[];

  @hasMany('property', { inverse: null, async: false })
  properties!: ModelRegistry['property'][];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    report: ReportModel;
  }
}
